export default __webpack_public_path__ + "static/media/1779.14bfab8b.png";